import { createContext, useContext } from 'react';

const FilterDatesContext = createContext(null);

export const useFilterDatesContext = () => {
    const context = useContext(FilterDatesContext);
    if (!context) {
        throw new Error("useFilterDatesContext must be used within a FilterPanelProvider");
    }
    return context;
};

export default FilterDatesContext;
